import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown } from 'antd';
import AppCheckBox from '@/ui/checkbox';
import mutilKnowledgeStore from './store';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect } from 'react';
import globalStore from '@/store/global';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const MultiKnowledge = observer((props) => {
  const {
    className = '',
    children,
    /**
     * pc_model_kn_mode 大模型
     * pc_sou_kn_mode 搜索
     * pc_ai_agent_kn_mode 智能体
     *
     * 全选 1
     * 全部选 2
     * 选择个人 3
     */
    sence:inputSence = "",
    onOpenChange = () => {},
    disabled,
  } = props;

  const store = mutilKnowledgeStore;
  const currentLocation = useLocation();
  const sence = useMemo(() => {
    if(inputSence){
      return inputSence;
    }

    const pathname = currentLocation.pathname;
    // 搜索
    if(
      // 新首页
      pathname == "/"
      || pathname == "/sosearch"
      // 搜索 智能体会话页(无效，该页面没有知识库)
      || /^\/aichat/.test(pathname)
    ){
      return "pc_sou_kn_mode";
    }
    // 大模型
    if(
      // 大模型首页
      pathname == "/chathome"
      // 大模型会话页(无效，该页面目前知识库是单选)
      || /^\/chat/.test(pathname)
    ){
      return "pc_model_kn_mode";
    }
    // 智能体
    if(
      // 智能体首页、起始页
      /^\/tools\/aiagent/.test(pathname)
      // 智能体会话页
      || /^\/agentchat/.test(pathname)
    ){
      return "pc_ai_agent_kn_mode";
    }
    return "";
  }, [inputSence, currentLocation]);

  useEffect(() => {
    globalStore.whenCloudReady(async () => {
      await store.reloadData();
      store.init(sence, true);
    });
  }, []);

  useEffect(() => {
    store.setDisabled(disabled);
  }, [disabled]);

  const [showDropdown, setShowDropdown] = useState(false);

  // 触发 Dropdown 重绘
  useEffect(() => {
    setShowDropdown(_ => !_);
    setShowDropdown(_ => !_);
  }, [store.selectAll, store.listSelected?.length]);

  const dropList = () => {
    return (
      <div
        className="w-260px rounded-12px flex flex-col items-center border-1px border-black border-opacity-10 bg-white overflow-hidden"
        style={{
          boxShadow: "0px 0px 2px 0px #0000001F, 0px 4px 8px 0px #0000001F"
        }}>
        <div
          className="flex h-48px px-16px items-center w-full flex-shrink-0 cursor-pointer"
          onClick={
            () => {
              store.toggleKnowledge();
            }
          }>
          <AppCheckBox
            checked={store.selectAllStatus != "none"}
            notAll={store.selectAllStatus == "some"}
            className="!size-16px mr-8px flex-shrink-0"
            />
          <div className="text-14px leading-20px font-bold text-black">基于 {store.total}个 知识库回答</div>
        </div>
        <div className="h-1px w-228px bg-black bg-opacity-6 flex-shrink-0"></div>
        <div
          id="multi-knowledge-list"
          className="px-8px py-7px flex-shrink w-full max-h-290px overflow-y-auto nw-scrollbar-thin">
          <InfiniteScroll
            dataLength={1}
            next={() => {
              store.loadMore();
            }}
            hasMore={store.hasMore}
            loader={null}
            scrollableTarget="multi-knowledge-list"
          >
            {
              store.listPersonal.map(item => {
                return (
                  <div
                    key='personal'
                    className="flex h-40px px-8px items-center w-full cursor-pointer"
                    onClick={
                      () => {
                        store.toggleKnowledge(item.folder_id);
                      }
                    }>
                    <AppCheckBox
                      checked={store.isSelected(item.folder_id)}
                      className="!size-16px mr-8px flex-shrink-0"
                      />
                    <div className="text-14px leading-20px text-black truncate">{item.name}</div>
                  </div>
                )
              })
            }

            {
              store.listCreated.length
              ? (
                <div key="title_created" className="pl-8px pt-8px text-black text-opacity-50">
                  我创建的专业知识库
                </div>
              )
              : null
            }
            {
              store.listCreated.map(item => {
                return (
                  <div
                    key={`created_${item.folder_id}`}
                    className="flex h-40px px-8px items-center w-full cursor-pointer"
                    onClick={
                      () => {
                        store.toggleKnowledge(item.folder_id);
                      }
                    }>
                    <AppCheckBox
                      checked={store.isSelected(item.folder_id)}
                      className="!size-16px mr-8px flex-shrink-0"
                      />
                    <div className="text-14px leading-20px text-black truncate">{item.name}</div>
                  </div>
                )
              })
            }

            {
              store.listShared.length
              ? (
                <div key="title_shared" className="pl-8px pt-8px text-black text-opacity-50">
                  我加入的分享知识库
                </div>
              )
              : null
            }
            {
              store.listShared.map(item => {
                return (
                  <div
                    key={`shared_${item.folder_id}`}
                    className="flex h-40px px-8px items-center w-full cursor-pointer"
                    onClick={
                      () => {
                        store.toggleKnowledge(item.folder_id);
                      }
                    }>
                    <AppCheckBox
                      checked={store.isSelected(item.folder_id)}
                      className="!size-16px mr-8px flex-shrink-0"
                      />
                    <div className="text-14px leading-20px text-black truncate">{item.name}</div>
                  </div>
                )
              })
            }
          </InfiniteScroll>
        </div>
      </div>
    )
  }
  return (
    <div className={` ${className}`}>
      <Dropdown
        dropdownRender={() => dropList()}
        trigger="click"
        placement="topLeft"
        disabled={disabled}
        open={showDropdown}
        onOpenChange={visible => {
          setShowDropdown(visible);
          onOpenChange(visible);
        }}
      >
        {children}
      </Dropdown>
    </div>
  )
});
export default MultiKnowledge;
